export const reactJSPageData = {
  hero: {
    heading: "React JS App Development Company",
    subtext:
      "Quokka Labs builds React applications that load fast, scale cleanly, and stay easy to maintain. Our custom react js development services provide new product builds to front-end modernization, delivering reliable UI architecture, reusable components, and secure integrations that support real business workflows. Get a React team that ships predictable releases with clear ownership.",
    buttonText: "Talk to an Expert",
    link: "https://quokkalabs.com/contact-us",
  },

  awardsSection: {
    title: "Award-Winning React JS App Development Company",
  },

  services: {
    heading: "React JS Development Services We Offer",
    intro:
      "Quokka Labs delivers React JS development services built for real product needs—new builds, modernization, and ongoing feature delivery. We create maintainable component systems, integrate cleanly with APIs, and improve performance across devices. From dashboards to customer portals, our React engineers ship stable releases with clear documentation and test coverage.",

    items: [
      {
        title: "React JS Web App Development",
        desc: "We build React applications for SaaS products, dashboards, customer portals, and internal tools. Expect a clean component structure, predictable state handling, and reusable UI patterns. We ship in milestones, validate functionality, and keep codebase growth controlled from day one.",
      },
      {
        title: "React Migration and Modernization",
        desc: "We modernize legacy front ends by upgrading React versions, replacing outdated patterns, and refactoring risky modules. Work is planned to avoid downtime and limit rewrite scope. You get improved stability, simpler maintenance, and a path to continuous improvement.",
      },
      {
        title: "React JS UI/UX Development",
        desc: "We translate product requirements into clear user flows and React interfaces that are consistent across screens. Our team builds responsive layouts, accessible components, and reusable UI patterns. You get a front end that's easy to use, easy to extend, and aligned with your brand.",
      },
      {
        title: "React JS API Integration",
        desc: "We integrate React applications with REST and GraphQL APIs using stable data-fetching patterns and strong error handling. This includes authentication flows, pagination, caching, and retries. You get reliable screens that stay fast and consistent even when network or backend conditions change.",
      },
      {
        title: "React JS Portal Development",
        desc: "We build portals for customers, partners, vendors, and internal teams—designed around roles, permissions, and workflow speed. This includes dashboards, document management, approvals, and reporting. You get a secure, scalable portal that reduces manual work and improves visibility.",
      },
      {
        title: "Enterprise React Application Development",
        desc: "We deliver enterprise-grade React apps built for large user bases, strict permissions, and complex business logic. Expect modular architecture, shared component libraries, and governance-ready standards. You get stable releases, clear ownership, and a front end that supports long-term change.",
      },
    ],
  },

  trutStats: {
    heading:
      "Our React JS App Development Company Expertise Proven by Real-World Results",
    items: [
      {
        value: "12+",
        label: "Years of Experience",
      },
      {
        value: "200+",
        label: "Projects Delivered",
      },
      {
        value: "60+",
        label: "Digital products designed and developed",
      },
      {
        value: "40%",
        label: "Faster delivery using AI engineering accelerators",
      },
    ],
  },

  mainServices: {
    heading: "Our Services",
    intro:
      "Quokka Labs builds digital products with clear architecture, strong performance, and secure integrations. We help teams launch and improve React applications that support real workflows—dashboards, portals, customer experiences, and internal tools—without creating long-term maintenance issues.",

    categories: [
      {
        title: "AI Development Services",
        items: [
          {
            title: "AI Consulting",
            desc: "We identify where AI can reduce effort or improve decisions, then define a practical rollout plan. This includes use-case validation, data readiness checks, cost estimates, and success metrics—so your team invests in AI work that supports real outcomes.",
            link: "./ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-phone.svg",
          },
          {
            title: "Generative AI Consulting",
            desc: "We assess where LLMs can improve support, search, documentation, and reporting. You get a clear path from prototype to production, with attention to privacy, evaluation methods, and guardrails that keep outputs useful and safe.",
            link: "./generative-ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-image.svg",
          },
          {
            title: "Agentic AI Development",
            desc: "We build workflow agents that execute multi-step tasks like routing, approvals, ticket handling, and data updates. Agents integrate with your systems through secure APIs, with audit logs and controls to ensure predictable behavior.",
            link: "./agentic-ai-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-programming.svg",
          },
          {
            title: "AI-Native Product Development",
            desc: "We design products where AI is part of the core experience—recommendations, classification, summarization, and decision support built into the workflow. You get an interface and backend logic that work together instead of AI bolted on later.",
            link: "./ai-native-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-voice.svg",
          },
          {
            title: "AI Security and Governance",
            desc: "We implement monitoring, access controls, data protection, and policy enforcement for AI features. This includes prompt security, output logging, evaluation, and role-based controls—especially important for regulated or high-scale environments.",
            link: "./ai-security-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-security.svg",
          },
          {
            title: "Generative AI Development",
            desc: "We develop LLM-based modules such as support assistants, internal chat tools, content helpers, and automated reporting. The focus is on reliability: defined intent, measurable quality, and integration with the product experience.",
            link: "./generative-ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-computer.svg",
          },
          {
            title: "AI Feature Development",
            desc: "We deliver end-to-end AI features—from model selection and evaluation to API integration and UI delivery. You get features that are explainable where needed, monitored in production, and designed for real user behavior.",
            link: "./ai-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-innovation.svg",
          },
          {
            title: "ML Development",
            desc: "We build and deploy machine learning models for forecasting, anomaly detection, optimization, and risk scoring. We handle data pipelines, training workflows, deployment, and ongoing model performance tracking.",
            link: "./ml-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-setting.svg",
          },
          {
            title: "AI/ML Engineering",
            desc: "We combine ML models and LLM capabilities to support both batch and real-time use cases. This approach helps teams balance automation, accuracy, and transparency across operational workloads and user-facing features.",
            link: "./artificial-intelligence-machine-learning-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-brain.svg",
          },
        ],
      },

      {
        title: "App Development Services",
        items: [
          {
            title: "Mobile Application Development",
            desc: "We build mobile apps that connect cleanly to your systems—authentication, data sync, reporting, and collaboration. The focus is stability, performance, and secure integration patterns that work across real network conditions.",
            link: "./mobile-app-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame.svg",
          },
          {
            title: "Web Application Development",
            desc: "We design and modernize web applications with modular architecture and secure APIs. This includes React-based front ends, scalable backend integration, and performance tuning so the app remains fast as features and users grow.",
            link: "./web-application-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/web-design.svg",
          },
          {
            title: "Data and Analytics",
            desc: "We turn product and business data into dashboards, KPIs, and decision-ready reporting. This includes event tracking, data modeling, visualization, and predictive insights that make performance easier to understand and improve.",
            link: "./data-analytics-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/data-recovery.svg",
          },
          {
            title: "Blockchain Development",
            desc: "We build blockchain-enabled solutions when audit trails and integrity matter—record verification, identity workflows, and multi-party validation. We focus on practical implementation, integration, and clear governance around what belongs on-chain.",
            link: "./blockchain-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame2.svg",
          },
          {
            title: "iOS Application Development",
            desc: "We develop iOS apps built for performance and reliability, with secure data flows and stable integrations. Delivery includes test coverage, release readiness, and maintainable architecture aligned with product growth.",
            link: "./ios-app-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Fra3.svg",
          },
          {
            title: "UI/UX Design",
            desc: "We design interfaces built for clarity and usability—information structure, flows, accessibility, and interaction patterns. The goal is simple: help users complete tasks faster with fewer errors and less friction.",
            link: "./ui-ux-design-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Fram4.svg",
          },
          {
            title: "DevOps Services",
            desc: "We set up CI/CD pipelines, infrastructure automation, monitoring, and environment management. This improves release reliability, reduces downtime risk, and makes scaling more predictable as your platform grows.",
            link: "./devops-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/wireless-cloud.svg",
          },
          {
            title: "Quality Assurance Engineering",
            desc: "We test for functionality, integration accuracy, performance, and security. QA is tied to acceptance criteria and real usage patterns, so releases stay stable and defects are caught early.",
            link: "./quality-analyst",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/phone-check.svg",
          },
          {
            title: "AR and VR",
            desc: "We build AR/VR experiences for training, simulation, visualization, and interactive product use cases. Work includes performance constraints, device support planning, and content pipelines that match your delivery goals.",
            link: "./ar-vr-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/vr-stroke-rounded.svg",
          },
        ],
      },

      {
        title: "Staff Augmentation",
        items: [
          {
            title: "Android Developers",
            desc: "Add Android engineers to accelerate delivery, stabilize releases, and improve app performance. We support clean architecture, secure integrations, and testing practices that reduce regression risk.",
            link: "./hire-android-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-programming.svg",
          },
          {
            title: "iOS Developers",
            desc: "Scale iOS delivery with engineers who can build new features, improve stability, and maintain clean integrations. Our focus is predictable releases and long-term maintainability.",
            link: "./hire-ios-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/appstore.svg",
          },
          {
            title: "Flutter Developers",
            desc: "Speed up cross-platform delivery with Flutter engineers who structure shared code for maintainability. We help teams avoid 'one-off' builds by enforcing patterns that scale.",
            link: "./hire-flutter-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/phone-developer.svg",
          },
          {
            title: "React Native Developers",
            desc: "Expand mobile roadmap with React Native engineers who build consistent experiences across platforms. We align app behavior with your API strategy and reduce duplicated development effort.",
            link: "./hire-react-native-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/react-stroke.svg",
          },
          {
            title: "Python Developers",
            desc: "Leverage Python engineers for backend services, automation, analytics workflows, and AI integrations. We prioritize clear APIs, performance, and reliable deployments.",
            link: "./hire-python-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/python.svg",
          },
          {
            title: ".NET Developers",
            desc: "Work with .NET developers to build secure, integration-ready systems. We support modernization, service architecture, and enterprise-grade workflows that require long-term stability.",
            link: "./hire-dotnet-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/server-stack.svg",
          },
          {
            title: "Node.js Developers",
            desc: "Add Node.js engineers for real-time features, event-driven services, and high-concurrency workloads. We focus on reliable systems, observability, and secure integration patterns.",
            link: "./hire-node-js-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/3rd-bracket.svg",
          },
          {
            title: "React JS Developers",
            desc: "Strengthen front-end delivery with React engineers who build modular interfaces connected to APIs. This includes component libraries, performance tuning, and testing workflows that support fast iteration.",
            link: "./hire-react-js-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-programming.svg",
          },
          {
            title: "Firebase Developers",
            desc: "Hire Firebase specialists to implement authentication, real-time data, cloud storage, and analytics. We design Firebase usage for security and scale, with clear rules and predictable data structures.",
            link: "./hire-firebase-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/fire-stroke.svg",
          },
        ],
      },
    ],
  },

  newsLetter: {
    heading: "Ready to Build and Scale Your React Application with Confidence?",
    desc: "From customer-facing products and SaaS platforms to internal tools, portals, and data-heavy dashboards, Quokka Labs delivers React applications built for speed, stability, and clean long-term ownership. Get a front end that integrates smoothly, performs under load, and supports continuous releases.",
    buttonText: "Get Started",
    link: "https://quokkalabs.com/contact-us",
  },

  caseStudies: {
    heading:
      "React JS App Development Company That Turns Roadmaps into Results",

    items: [
      {
        title: "Quixy (Hamta)",
        desc: "Quixy is an intelligent document processing automation product built to simplify document-heavy workflows through no-code automation. Quokka Labs contributed the frontend development, focusing on a user-friendly interface, accessibility, performance optimization, and seamless interaction with Hamta's document processing capabilities.",
        results: [
          "70% Faster Document Processing",
          "90% Higher Operational Efficiency",
        ],
        url: "",
        color: "#FFDDF4",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/quixy-portfolio-new.webp",
      },
      {
        title: "LearnLoft",
        desc: "LearnLoft is a data-driven leadership development platform that helps organizations identify strengths, close performance gaps, and make better leadership decisions through measurable insights. Quokka Labs designed, developed, and deployed the platform, creating a structured, user-friendly experience that supports professional growth and organizational effectiveness.",
        results: [
          "90% Faster Leadership Onboarding",
          "70% Better Access to Leadership Insights",
        ],
        url: "./learnloft",
        color: "#C6DFFF",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/learnloftPort.webp",
      },
    ],
  },

  keyFeatures: {
    heading: "Key Features We Integrate into React JS Applications",

    items: [
      {
        title: "Scalable React Architecture for Growing Products",
        desc: "React products break when structure isn't planned early. We build front ends that stay organized as screens, teams, and features expand—so velocity stays consistent and rework stays low.",
        points: [
          "Feature-based structure with clear module ownership",
          "Reusable component library and shared UI patterns",
          "Predictable state management for complex workflows",
          "Code-splitting and lazy loading for faster page loads",
          "Configuration-driven UI for faster iteration",
          "Documentation and standards that support team scale",
        ],
      },
      {
        title: "Real-Time UI and Workflow-Ready Interfaces",
        desc: "Many React apps depend on live updates—status changes, notifications, queues, and operational dashboards. We implement real-time patterns that keep the UI accurate and responsive without performance drops.",
        points: [
          "Live updates with WebSockets, SSE, or event streams",
          "Optimistic UI and reliable sync for user actions",
          "Background refresh patterns with caching and retries",
          "Activity feeds, alerts, and notification centers",
          "Role-based task views and workflow screens",
          "Performance tuning for high-frequency updates",
        ],
      },
      {
        title: "Secure API-First Integration Layer",
        desc: "React applications succeed when data flow is stable and secure. We implement clean API integration patterns that reduce front-end complexity and keep access control consistent across your product.",
        points: [
          "REST and GraphQL integration with typed contracts",
          "Auth flows with SSO/OAuth2/JWT and session handling",
          "Centralized API client layer with error normalization",
          "Secure file uploads, downloads, and token-based access",
          "Webhook-driven UI updates and event handling",
          "Integration with CRMs, analytics, payments, and internal tools",
        ],
      },
      {
        title: "Governance, Automation, and Compliance-Friendly UX",
        desc: "Enterprise products need more than screens—they need traceability, permissions, and repeatable processes. We build React interfaces that support compliance workflows and reduce manual work for operations teams.",
        points: [
          "RBAC/ABAC-driven navigation and permission controls",
          "Approval flows, exception handling, and audit-ready actions",
          "Admin panels for configuration, roles, and feature access",
          "Form validation rules aligned with policy requirements",
          "Action logs and activity history views for traceability",
          "Secure session controls and account-level safeguards",
        ],
      },
    ],
  },

  capabilities: {
    heading: "What You Get with Our React JS App Development Company Expertise",
    subtext:
      "As a react js app development company, Quokka Labs focuses on outcomes that keep your product reliable after launch: clear front-end architecture, fast performance, secure integrations, and code your team can maintain. As your react js application development company, we build React systems that scale in users, features, and workflows—without constant rewrites.",

    items: [
      {
        title: "Product-Ready React Architecture",
        desc: "We design React codebases that stay organized as the app grows—feature modules, reusable components, and predictable state patterns that support continuous delivery. This is how a react js software development company keeps velocity high without creating front-end debt.",
      },
      {
        title: "Performance-First UI Engineering",
        desc: "We improve load time and runtime responsiveness with bundle control, code-splitting, rendering optimization, and caching. Your React app stays fast on real devices, not just in local builds.",
      },
      {
        title: "Secure Integration and Access Control",
        desc: "We implement secure auth flows (SSO/OAuth/JWT), permission-based UI, and guarded routes so your front end matches your security requirements. If you need a react js development company USA teams trust, we build with compliance and risk reduction in mind.",
      },
      {
        title: "Integration-First Front-End Delivery",
        desc: "We build stable API integration layers for REST and GraphQL, normalize errors, and handle retries, pagination, and caching. That means fewer production issues and cleaner collaboration with backend teams—especially for custom react js development services.",
      },
      {
        title: "Workflow-Driven UX for Complex Products",
        desc: "We build React interfaces for approvals, task routing, notifications, admin controls, and audit-friendly experiences. Your users get clearer workflows, and your operations team gets fewer manual steps.",
      },
      {
        title: "Monitoring, Quality, and Release Confidence",
        desc: "We add front-end observability, error tracking, performance monitoring, and automated testing where it matters most. The result is fewer regressions, faster debugging, and predictable releases across environments.",
      },
    ],
  },

  ourProcess: {
    heading: "Our End-to-End Delivery Process for Modern React JS Apps",

    subtext:
      "As a react js app development company, Quokka Labs follows a delivery process built for predictable releases and long-term maintainability. From discovery to launch, we keep scope clear, quality measurable, and integrations stable—so your React product scales without slowing your team down.",

    steps: [
      {
        number: "01",
        title: "Discovery and Requirements Alignment",
        desc: "We map goals, users, workflows, and success metrics. Then we define scope, priorities, risks, and acceptance criteria—so delivery stays controlled and decisions are documented.",
      },
      {
        number: "02",
        title: "UI/UX Planning and Component Strategy",
        desc: "We translate flows into screens and a reusable component plan. This includes accessibility standards, responsive behavior, and design system alignment to keep the interface consistent.",
      },
      {
        number: "03",
        title: "Front-End Architecture and Technical Setup",
        desc: "We set up the React foundation: routing, state approach, data-fetching patterns, environment configuration, and code standards. This reduces rework and supports team scale.",
      },
      {
        number: "04",
        title: "Iterative Development and Sprint Delivery",
        desc: "We build in short cycles with reviews, demos, and QA checks. Features are delivered as shippable increments with clean integration to APIs and clear release notes.",
      },
      {
        number: "05",
        title: "Testing, Performance, and Security Validation",
        desc: "We validate critical paths with unit and E2E tests, performance checks, and security reviews. Issues are fixed early to prevent production regression and instability.",
      },
      {
        number: "06",
        title: "Launch, Monitoring, and Continuous Support",
        desc: "We support deployment, add monitoring and error tracking, and stabilize post-release. After launch, we handle enhancements, dependency updates, and ongoing optimization based on product data.",
      },
    ],
  },

  compliance: {
    heading:
      "Built to Support Enterprise Security and Compliance for React JS Applications",

    intro:
      "Compliance can't be a patch after launch. As a react js app development company, Quokka Labs builds React products with security controls, privacy practices, and audit-ready workflows built into delivery. Whether you're shipping a customer portal, SaaS platform, or internal dashboard, we design for data protection, traceability, and operational control - so your team can scale with less risk.",

    sections: [
      {
        title: "Application Security and Threat Reduction",
        desc: "We harden React applications against common client-side risks and production issues. That includes secure authentication flows, protected routes, safe data handling, dependency management, and security-focused reviews tied to your release process.",
      },
      {
        title: "Data Privacy and Access Governance",
        desc: "We support least-privilege access through role-based UI controls, secure session handling, and careful treatment of sensitive data. When regional requirements apply, we align front-end behavior with your data policies—logging, consent, and retention included.",
      },
      {
        title: "Reliability, Monitoring, and Production Readiness",
        desc: "We implement error tracking, performance monitoring, and release safeguards so issues surface early and fixes stay controlled. This includes structured logging support, incident-ready dashboards, and stability practices that keep your React interface dependable under traffic spikes.",
      },
    ],

    standards: [
      "GDPR – Data privacy and protection requirements",
      "CCPA/CPRA – Consumer data privacy obligations",
      "SOC 2 – Security and operational controls for SaaS",
      "ISO/IEC 27001 – Information security management practices",
      "OWASP – Secure application and front-end best practices",
      "PCI DSS – Payment data handling requirements (when applicable)",
    ],
  },

  industries: {
    heading:
      "We Deliver Enterprise-Grade React Transformation Across Key Industries",

    subtext:
      "As a react js app development company, Quokka Labs builds React applications for organizations that need secure access, fast performance, and predictable UI behavior at scale. As your react js application development company, we deliver portals, dashboards, and workflow-driven web products that integrate cleanly with enterprise systems and support compliance-focused delivery.",

    items: [
      {
        title: "Healthcare",
        image: "",
        points: [
          "Patient portals, appointment flows, and care coordination interfaces built in React",
          "Secure role-based UI for clinicians, staff, and administrators",
          "Integration-ready front ends for EHR/EMR connectivity, reporting, and visibility",
          "Privacy-aware UX patterns for sensitive data and audit-friendly actions",
        ],
      },
      {
        title: "Manufacturing",
        image: "",
        points: [
          "React dashboards for production monitoring, inventory, and plant operations",
          "Real-time UI updates for logistics, procurement, and supply chain workflows",
          "ERP-integrated portals for multi-site planning and execution",
          "Workflow screens that reduce manual steps and improve process consistency",
        ],
      },
      {
        title: "Education",
        image: "",
        points: [
          "Scalable React web platforms for LMS modules and student operations",
          "Secure portals for admissions, assessments, learning content, and progress tracking",
          "Multi-role experiences for learners, faculty, and administrators",
          "Analytics and reporting views that support institutional decision-making",
        ],
      },
      {
        title: "Real Estate",
        image: "",
        points: [
          "React portals for listings, tenant workflows, and transaction pipelines",
          "CRM-integrated interfaces for brokers, agencies, and customer coordination",
          "Document workflows with permissions, version tracking, and e-sign support",
          "Performance-focused UI for search, filtering, and high-usage screens",
        ],
      },
      {
        title: "FinTech",
        image: "",
        points: [
          "Secure React applications for payments, onboarding, lending, and account workflows",
          "Permission-based UX aligned with KYC/AML flows and audit requirements",
          "High-availability front ends built for transaction-heavy usage",
          "API-first integration patterns with banking partners and identity providers",
        ],
      },
      {
        title: "Retail",
        image: "",
        points: [
          "Customer portals and internal tools for omnichannel operations",
          "Order, returns, fulfillment, and inventory workflows built for speed",
          "CRM-linked loyalty and personalization experiences",
          "Performance tuning for peak traffic, promotions, and seasonal spikes",
        ],
      },
    ],
  },

  // techStack: {
  //   heading: "Our Tech Stack",

  //   intro:
  //     "We use a modern, production-ready tech stack engineered to support secure, scalable, and high-performance React JS application development services.",

  //   categories: [
  //     {
  //       title: "Frontend",
  //       items: [
  //         "React.js",
  //         "Next.js",
  //         "TypeScript",
  //         "Tailwind CSS",
  //         "JavaScript",
  //       ],
  //     },
  //     {
  //       title: "Mobile",
  //       items: ["iOS (Swift)", "Android (Kotlin)", "Flutter", "React Native"],
  //     },
  //     {
  //       title: "Backend",
  //       items: ["Node.js", "Python", ".NET", "Java", "PHP"],
  //     },
  //     {
  //       title: "Database",
  //       items: ["MongoDB", "PostgreSQL", "MySQL", "Firebase"],
  //     },
  //     {
  //       title: "Cloud & DevOps",
  //       items: ["AWS", "Azure", "Google Cloud", "Docker", "CI/CD Pipelines"],
  //     },
  //     {
  //       title: "AI & Analytics",
  //       items: [
  //         "Machine Learning",
  //         "Generative AI",
  //         "Data Analytics",
  //         "TensorFlow",
  //       ],
  //     },
  //   ],
  // },

  newsLetter2: {
    heading:
      "Cut React Development Overhead by 50% With a Cleaner Front-End Architecture",

    subtext:
      "Whether you're launching a new React product, modernizing a legacy UI, or scaling a high-traffic customer portal, Quokka Labs helps you reduce rework, improve performance, and ship with confidence. Teams typically see 20–40% fewer UI regressions and 15–30% faster releases through stronger structure, testing, and performance tuning.",

    buttonText: "Book a Call",
    link: "https://quokkalabs.com/contact-us",
  },

  ai_Focused: {
    heading: "AI-Driven Intelligence for Modern React JS Applications",

    subtext:
      "Quokka Labs adds AI features and real-time insights to React products to improve decisions, reduce manual work, and make interfaces more helpful. As a react js app development company, we design AI experiences that fit into real workflows—dashboards, portals, support tools, and SaaS products—so teams get measurable value, not demos.",

    items: [
      "AI Consulting for React Product Strategy",
      "Predictive Analytics and Decision Intelligence Dashboards",
      "AI-Assisted UX for Search, Support, and Knowledge Access",
      "Workflow Automation with AI Assistants and Task Routing",
      "Fraud Signals, Risk Scoring Views, and Security Monitoring UI",
      "AI-Driven Optimization and Automated Recommendations",
    ],
  },

  whyChoose: {
    heading:
      "Why Quokka Labs is the React JS App Development Company Built for Scalable, Secure Products",

    subtext:
      "Quokka Labs is a react js app development company focused on long-term product reliability, not short-term delivery. We build React applications with clean architecture, secure integration patterns, and performance discipline, so your team can scale features and users without constant rework or release risk.",

    items: [
      {
        number: "01",
        title: "Architecture That Prevents Front-End Debt",
        desc: "We design feature-based React structures, reusable components, and clear state patterns that stay stable as teams and modules grow. This keeps development predictable and reduces refactors.",
      },
      {
        number: "02",
        title: "Performance Engineering Built Into Delivery",
        desc: "We prioritize Core Web Vitals, bundle control, and rendering efficiency from the start. Your product stays fast on real devices, even as pages, data, and UI complexity increase.",
      },
      {
        number: "03",
        title: "Secure Auth and Permission-Driven UX",
        desc: "We implement secure login flows (SSO/OAuth/JWT), guarded routes, and role-based UI behavior that aligns with your backend access policies—critical for portals, SaaS, and enterprise tools.",
      },
      {
        number: "04",
        title: "API Integrations That Stay Maintainable",
        desc: "As a react js application development company, we build a stable integration layer for REST/GraphQL with normalized errors, retries, caching, and clean data contracts—so changes don't break your UI.",
      },
      {
        number: "05",
        title: "Quality Systems That Reduce Regressions",
        desc: "We add the right level of unit, integration, and E2E tests for your risk areas, plus CI checks and code standards. The result is fewer production issues and more confident releases.",
      },
      {
        number: "06",
        title: "A Delivery Model Designed for Ownership",
        desc: "As a react js software development company, we document decisions, standardize patterns, and ship with handoff clarity. Your internal team can take over, extend features, or scale with us without friction.",
      },
    ],
  },

  hireCTATeamBanner: {
    heading: "Hire Top Notch Developers Around You!",

    subtext:
      "Engaging with our engineers accelerates your roadmap and strengthens compliance.",

    buttonText: "Hire Developer",
    link: "https://quokkalabs.com/contact-us",
  },

  nextGenTech: {
    heading:
      "Future-Ready Technologies That Strengthen Your React JS Applications",

    subtext:
      "Quokka Labs builds React products that are ready for what comes next—more users, more data, more integrations, and higher security expectations. As a react js app development company, we layer in modern capabilities without adding complexity that slows delivery. As your react js application development company, we focus on stable architecture, measurable performance, and production-ready integrations.",

    items: [
      {
        title: "Cloud",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/cloud-new-new.webp",
        desc: "We build React applications that deploy cleanly across modern cloud environments with predictable releases and fast delivery. This includes SSR/edge strategies when needed, environment management, and performance tuning to keep your UI responsive across regions and devices.",
      },
      {
        title: "Blockchain",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/block-chain-new.webp",
        desc: "When your product needs verifiable records—ownership, approvals, or audit trails—we integrate blockchain-backed workflows into the React experience. Users can validate actions, track history, and manage permissions through clear UI patterns that support compliance-heavy processes.",
      },
      {
        title: "IoT",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/iot-new-new.webp",
        desc: "We build React dashboards and control panels for device and sensor ecosystems. This includes real-time status views, alerts, asset monitoring, and operational controls—designed for high-frequency updates and reliable data sync across distributed environments.",
      },
      {
        title: "Data Science and Analytics",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/data-engi-new.webp",
        desc: "We turn product and operational data into usable dashboards inside your React app. That includes event tracking, KPI views, forecasting widgets, and reporting flows that help teams monitor performance and make faster decisions.",
      },
      {
        title: "Robotic Process Automation (RPA)",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/automation-new.webp",
        desc: "We integrate React portals with RPA workflows to reduce manual work—approvals, reconciliations, data entry, and routine reporting. Users get clear task queues, status visibility, and exception handling that keeps automation controllable.",
      },
      {
        title: "Generative AI",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/gen-ai-new.webp",
        desc: "We add GenAI features such as knowledge search, document helpers, support assistants, and reporting tools directly into the React UI. Delivery includes guardrails, evaluation, and secure integration so outputs stay relevant and safe.",
      },
      {
        title: "Machine Learning (ML)",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ml-ne.webp",
        desc: "We integrate ML-driven features into React experiences—recommendations, prediction-based insights, anomaly signals, and personalization. The UI is designed to explain outcomes clearly, support human review, and adapt as models improve.",
      },
      {
        title: "Agentic AI",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/agentic-ai-new.webp",
        desc: "We build agent-powered workflows that execute multi-step tasks across your tools—routing, follow-ups, escalations, and data updates—while keeping users in control. The React interface provides approvals, audit trails, and visibility into each action.",
      },
    ],
  },

  blogs: {
    heading: "What's New in React JS App Development?",
  },

  faqs: {
    heading: "FAQs: React JS App Development Company",

    items: [
      {
        question:
          "How much does it cost to hire a react js app development company?",
        answer:
          "Most React web apps fall into a wide range because scope drives cost more than the framework. Typical pricing is based on (1) team rates and (2) how much work is truly 'product' vs. 'polish.' Hourly rates vary by region. Simple web apps can start in the tens of thousands, while complex or enterprise platforms can exceed $200K+ depending on integrations, security, and QA.",
        points: [
          "Number of roles (admin, staff, customers)",
          "Integrations (payments, CRM/ERP, SSO)",
          "Data-heavy UI (dashboards, real-time views)",
          "QA automation and performance requirements",
        ],
      },
      {
        question: "How long does React app development usually take?",
        answer:
          "A realistic timeline depends on how many workflows, roles, and integrations you need at launch. Many teams plan in months, not weeks.",
        points: [
          "Simple builds: ~2–4 months",
          "Medium complexity products: ~4–8 months",
          "Complex/enterprise systems: ~9–12+ months",
          "Clear acceptance criteria speeds delivery",
          "Stable UI patterns (design system/components) speeds delivery",
          "API contracts agreed early speeds delivery",
        ],
      },
      {
        question: "React vs Next.js: which is better for SEO?",
        answer:
          "React is a UI library; SEO depends on how your pages render and how quickly meaningful content loads. Next.js adds built-in rendering options that can help when SEO is a requirement. Google can index JavaScript, but JS-heavy sites still need careful handling to avoid rendering/indexing gaps.",
        points: [
          "Next.js for pre-rendered HTML: marketing pages, content hubs, public landing pages via SSG/SSR",
          "A common approach: use Next.js for public/SEO pages and React patterns for app-like areas behind login",
          "Google can index JavaScript but JS-heavy sites need careful handling",
        ],
      },
      {
        question:
          "What do 'custom react js development services' usually include?",
        answer:
          "Custom work should mean you're not getting a cookie-cutter UI or a template with light edits. It should include the foundation your team can maintain and extend. This is what turns a build into a product your team can evolve without rewrites.",
        points: [
          "UI architecture (feature modules, routing, state strategy)",
          "Reusable components and design system alignment",
          "API integration layer (REST/GraphQL, caching, error handling)",
          "Auth + permissions (SSO/OAuth/JWT, guarded routes)",
          "Testing on critical paths (unit + E2E where needed)",
          "Performance baseline and monitoring plan (Core Web Vitals, error tracking)",
        ],
      },
      {
        question:
          "How do you make a React app fast and improve Core Web Vitals?",
        answer:
          "Performance is measurable. We focus on load speed, interactivity, and layout stability—because those are the user outcomes Core Web Vitals track. Targets: LCP aim for 2.5s or less, INP aim for 200ms or less, CLS aim for 0.1 or less.",
        points: [
          "Code-splitting and route-level lazy loading",
          "Bundle and dependency trimming",
          "Render tuning (memoization only where it helps)",
          "Caching + request deduping for API calls",
          "Image strategy and layout stabilization",
        ],
      },
      {
        question: "How do you secure a React application?",
        answer:
          "React runs in the browser, so security is about what you expose, how you authenticate, and how you handle data. We build the UI to reduce risk and align with server-side policies. Security is a process, not a one-time checklist.",
        points: [
          "Follow OWASP Top 10 awareness to avoid common web risks",
          "Secure auth flows (SSO/OAuth/JWT), safe session handling, and guarded routes",
          "Least-privilege UI (RBAC/ABAC-driven screens and actions)",
          "Dependency hygiene and routine patching",
          "Input handling patterns and safe rendering",
          "Logging/monitoring for suspicious behavior",
        ],
      },
      {
        question:
          "Can you migrate from a legacy front end to React without a full rewrite?",
        answer:
          "Yes—many teams migrate in phases to reduce risk and avoid downtime. A phased modernization approach is often the safest path.",
        points: [
          "Audit: map routes, dependencies, and risky flows",
          "Strangle pattern: introduce React in one section at a time",
          "Shared UI layer: standardize components to prevent fragmentation",
          "API contract cleanup: stabilize data shape and error handling",
          "Decommission: remove legacy modules after parity is validated",
        ],
      },
      {
        question:
          "Do you provide React JS maintenance and support after launch?",
        answer:
          "Yes. Most products need ongoing work to stay stable: dependency updates, bug fixes, new features, and performance tuning. Many teams budget ongoing maintenance as a percentage of build cost (often 15–20% per year as a benchmark), then adjust based on release frequency and complexity.",
        points: [
          "Security patches and dependency upgrades",
          "Regression fixes and small enhancements",
          "Monitoring review (errors, performance, uptime signals)",
          "UX improvements based on analytics and user feedback",
          "Release management support (staging, production checks)",
        ],
      },
      {
        question: "What testing should a React product include?",
        answer:
          "Testing should match risk. We prioritize the paths that break revenue, security, or core workflows and align coverage across layers.",
        points: [
          "Unit tests: utilities and critical components",
          "Integration tests: form flows, API states, permission behavior",
          "E2E tests: login, checkout, onboarding, admin actions",
          "Accessibility checks on key templates",
          "Performance regression checks (before big releases)",
          "CI gates to prevent broken main branch deployments",
        ],
      },
      {
        question:
          "How do I choose the right react js application development company?",
        answer:
          "Choose based on your product risk: scale, security, and long-term ownership. Whether you're comparing a react js software development company or a react js development company USA against offshore options, due diligence matters.",
        points: [
          "Architecture examples: modular structure, state strategy, component standards",
          "Quality system: code reviews, CI checks, test approach",
          "Security posture: OWASP awareness, access control discipline",
          "SEO plan (if needed): SSR/SSG strategy, rendering approach",
          "Ownership terms: source code rights, documentation, handoff clarity",
          "Proof of delivery: case studies tied to outcomes (performance, stability, speed)",
        ],
      },
    ],
  },
};
